import React, { Component } from "react";
import { connect } from "react-redux";
import FieldCard from "components/fragments/FieldCard";
import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "assets/stylesheets/FieldsOfStudy.scss";

class FieldsOfStudy extends Component {
  constructor(props) {
    super(props);
    this.headingRef = React.createRef();
  }

  componentDidUpdate = (prevProps) => {
    const { success, loading } = this.props;
    if (success && !loading && prevProps.loading) {
      document
        .getElementById("fields-of-study-container")
        .scrollIntoView({ behavior: "smooth" });
      this.headingRef.current.focus({ preventScroll: true });
    }
  };

  getSumProbabilities = () => {
    const { category } = this.props;
    let sum = category.reduce((total, obj) => {
      return total + parseFloat(obj.probability);
    }, 0);
    return sum;
  };

  render() {
    const { category, other, loading, error, success } = this.props;
    const initialFields = !loading && !error && !success;
    if (initialFields) return <div></div>;
    else if (loading)
      return (
        <Spin
          indicator={<Loading3QuartersOutlined style={{ fontSize: 24 }} spin />}
        />
      );
    else if (error) return <div>{error}</div>;

    const sum = this.getSumProbabilities();

    return (
      <div id="fields-of-study-container">
        <h2 className="major-heading" tabIndex={0} ref={this.headingRef}>
          Top fields of study
        </h2>
        <p>
          Applicants with your academic background were most commonly made
          offers to courses in these fields of study.
        </p>
        <div className="cards__container">
          {category.map((rec, i) => (
            <FieldCard
              firstLink={i === 0}
              key={rec.id}
              fos={true}
              recommendation={rec}
              sum={sum}
            />
          ))}
        </div>

        <h2 className="related-heading"> Related fields </h2>
        <div className="cards__container">
          {other.map((rec) => (
            <FieldCard key={rec.id} recommendation={rec} fos={false} />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { category, other, loading, error, success } = store.fieldsReducer;
  return {
    category,
    other,
    loading,
    error,
    success,
  };
};

export default connect(mapStateToProps)(FieldsOfStudy);
